<!-- 组件说明 -->
<template>
     <div class="tool-box" ref="toolBox" :style=" {'top' : autoHeight}">
        <div class="qrcode">
          <el-popover
          
            placement="right"
            width="188"
            trigger="hover"
         
          >
          <div class="qrcode-box">
            <div class="qrcode-item">
              <div class="qrcode-img">
                <img :src="require('@/assets/images/logo/app_ewm.png')" alt="">
              </div>
              <p>APP购药</p>
            </div>
             <div class="qrcode-item">
              <div class="qrcode-img">
                <img :src="require('@/assets/images/logo/vx_ewm.png')" alt="">
              </div>
              <p>微信购药</p>
            </div>
          </div>
            <img
              slot="reference"
              :src="require('@/assets/images/icon_qrcode.png')"
              alt=""
            />
          </el-popover>
        </div>
        <div class="shoppinglist" @click="topage(2)" v-if="$store.state.hasLogin">
          <img :src="require('@/assets/images/cgqd(1).png')" alt="">
        </div>
         <div class="sm" @click="topage(3)" v-if="$store.state.hasLogin && showSm">
        <img :src="require('@/assets/images/x_smtj.png')" alt="" />
      </div>
         <div
        class="dh"
        @click="topage(1)"
        v-if="$store.state.hasLogin && dhtx"
      >
        <img :src="require('@/assets/images/icon_dh.png')" alt="" />
      </div>
      </div>
</template>

<script>
    //import x from ''
    export default {
      props:["top"],
        components: {

        },
        data () {
            return {
             autoHeight:'',
              dhtx:'',
              showSm:''
            };
        },
        computed: {

            
        },
        methods: {
          topage(type){
            if(type == 1){
              this.$router.push({ name: "replenishList"});

            }else if(type==2){
               this.$router.push({name:'shoppinglist'})

            } else if (type == 3) {
               this.$router.push({ name: "smActivityList" });
            }
          }

        },
        watch:{
          top:{
            handler(t,f){
               this.autoHeight = t + 'px'
            }
          }
        },
        created(){
          this.autoHeight = this.top + 'px'
          
        },
        mounted(){
          this.dhtx = JSON.parse(sessionStorage.getItem("isReplenish"));
          this.showSm = JSON.parse(localStorage.getItem("smActivity"));

          console.log(this.dhtx)

        }
        

    }
</script>

<style lang='scss' scoped>
.tool-box {
   position: fixed;
   top: 0;
  //right: 6vw;
  z-index: 999;
   margin-right: -684px;
   right: 50%;
   display: flex;
    flex-direction: column;
    align-items: center;
cursor: pointer;
  img {
    margin-bottom: 12px;
  }
}
.qrcode-box{
  .qrcode-item{
    display: flex;
    flex-direction: column;
   align-items: center;
   margin: 24px 0 16px 0;
   .qrcode-img{
     margin-bottom: 12px;
     width: 130px;
     height: 130px;
     img{
       @include size(100%,100%)
     }
   }
   p{
     font-size: 14px;
     color: #808080;
   }
  }
}
// .shoppinglist{
//   background-color: #fff;
//     width: 44px;
//     height: 44px;
//     font-size: 14px;
//     color: #ff3e3e;
//     padding: 7px;
//     margin-bottom: 12px;
//     border: 1px solid #f4f4f4;
// }
.dh{
  width: 58px;
  height: 58px;
  img{
    @include size (100%,100%)
  }
}
.sm{
  width: 44px;
  height: 44px;
  margin-bottom: 12px;
  img{
    @include size(100%,100%)
  }
}
</style>


// WEBPACK FOOTER //
// src/components/plugins/qrcode.vue